import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { getTestIds } from '../../../../../utils/TestIds';
import { Badge } from '../../../../Badge';
import { BulletList, BulletListItem } from '../../../../BulletList';
import { Typography } from '../../../../Typography';
import styles from '../cells.module.scss';
export function ListCell(param) {
    let { value, emptyText, useBadgeColor, testId } = param;
    const entries = Array.isArray(value) ? value : [];
    const testIds = getTestIds(testId);
    if (entries.length === 0) {
        return /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            skin: "disabled",
            testId: testId,
            children: emptyText
        });
    }
    return /*#__PURE__*/ _jsx(BulletList, {
        spacing: "compact",
        className: styles.listCell,
        testId: testId,
        children: entries.map((entry, index)=>{
            var _ref;
            return /*#__PURE__*/ _jsx(BulletListItem, {
                custom: true,
                bulletSize: "small",
                bulletAlignment: "firstLine",
                children: /*#__PURE__*/ _jsxs("span", {
                    className: styles.listItemContent,
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            as: "span",
                            variant: "paragraph2",
                            testId: testIds.item(index),
                            children: entry.text
                        }),
                        entry.badge != null && /*#__PURE__*/ _jsx(Badge, {
                            skin: (_ref = useBadgeColor === null || useBadgeColor === void 0 ? void 0 : useBadgeColor(entry.badge)) !== null && _ref !== void 0 ? _ref : 'primary',
                            size: "small",
                            rounded: true,
                            outlined: true,
                            testId: testIds.badge(index),
                            children: entry.badge
                        })
                    ]
                })
            }, entry.text);
        })
    });
}
